/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useState, useCallback } from 'react';
import Pagination from '../../../components/Pagination';
import 'tw-elements';
import { useLocation, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmationPrompt from '../../../components/ConfirmationPrompt';
import AnimatedModel from '../../../components/Animation/AnimatedModel';
import { dataService } from '../../../services/data.services';
import GlobalContext from '../../../components/Context/GloablContext';
import Table from './components/Table';
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow';
import { GroupsLedgers } from './GroupsLedgersSlice';
import CardHeader from '../../../components/CardHeader';
import Debounce from '../../../CommonMethods/Debounce';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';

const ManageGroupsLedgers = () => {
    const { setToastErrorMessage, setToastmessage} = useContext(GlobalContext);
    const dispatch = useDispatch();
    const GroupsLedgersList = useSelector(state => state.GroupsLedgersSlice);
    const { List} = GroupsLedgersList;
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [searchParams, setSearchParams] = useSearchParams({page_number: 1,type:"ledger"});
    const [email, setemail] = useState('')
    const [fistLoading, setFirstLoading] = useState(true)
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [filterCount, setFilterCount] = useState(0)
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
   
    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        setSearchParams({ page_number: 1, type: "ledger" });
    }
    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getBranch = useCallback(async () => {
        setLoading(true);
        try {
            const branch_id = await GetBranchId()
            dispatch(GroupsLedgers(`groups-and-ledgers?branch_id=${branch_id}&${searchParams.get('page_number') === null ? 'page_number=1' : `page_number=${searchParams.get('page_number')}`}&${searchParams.get('sort') === null ? 'sort=created_at%2Bdesc' : `sort=${encodeURIComponent(searchParams.get('sort'))}`}${searchParams.get('type') === null ? '' : `&filter=true&isInactive=true&type=${encodeURIComponent(searchParams.get('type'))}`}${searchParams.get('search') === null ? '' : `&search=${encodeURIComponent(searchParams.get('search'))}`}`)).then((response) => {
                if (response?.payload?.data.status===200) {
                    if(response?.payload?.data?.data?.data?.length === 0 && searchParams.get('search')===null && response?.payload?.data?.data?.total_count === 0) {
                        setFirstLoading(true);
                    } else {
                        setEmptyScreenMessage("No matching records found.");
                        setFirstLoading(false)
                    }
                    if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setEmptyScreenMessage("No data found");

                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
            // setLoading(false);
        } catch (error) {
            handleLoadData()
            setEmptyScreenMessage("No data found");
            console.error(error);
            setLoading(false);
        }
    }, [location]);


    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
        // getBranch()
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setEmptyScreenMessage("It seems there's nothing to display here.")
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value);}
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }


    /**
     * The function `handleFilters` updates the search parameters based on the key-value pair provided
     * and sets the loading state to true.
     */
    const handleFilters = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        params.filter = true
        console.log('value='+value)
        if(key === 'all'){
            delete params['filter'];
            delete params['type'];
        } 
        else params['type'] = (value===null?null:(value==='groups'?'group':'ledger'))
        setSearchParams({ ...params})
    }

    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );

    /* `useEffect(() => { getBranch(); }, [getBranch]);` is a hook that is used to run
    the `getBranch` function whenever the `getBranch` function changes. In this case,
    the `getBranch` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getBranch` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        setsearchFieldDebounce(searchParams.get('search') !== null ? decodeURIComponent(searchParams.get('search')) : '')
        getBranch();
    }, [searchParams]);


    /**
     * The function sets the confirmation state to an empty object when a confirmation click event
     * occurs.
     */
    const handleConformationClick = () => {
        setConfirmationState({});
    }

    /**
     * This function handles the activation of a user account and updates the user list accordingly.
     */
    const handleOnCLickActivate = async(e) => {
        setLoadingActivation(true);
        try {
            let body = { }
            if(confirmationState.status !== "Reset Password") {
                body = {
                    "status": confirmationState.status === 'Activate' ? true : false             
                }
            }
            let endpoint= confirmationState.status==="Reset Password"?`admin-users/reset-password/${confirmationState.item.email_address}`:`admin-users/update/${confirmationState.item.email_address}`
            if(confirmationState.status==="Reset Password"){
                body={
                    reset:true
                }
            }
            const response = await dataService.PatchAPI(body,endpoint);
            setLoadingActivation(false);
            if (response.data.success_status) setToastmessage(response.data.message);
            else setToastErrorMessage(response.data.message);
            handleConformationClick();
            setLoading(true)
            getBranch();
        } catch (error) {
            handleConformationClick();
            setLoadingActivation(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }

    /**
     * The function `getCount` counts the number of non-empty arrays in the `FilterCheckbox` object and
     * sets the `filterCount` state variable accordingly.
     */
    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item]?.length !== 0) {
                count += 1
            }
        })
        if(type) {
            setFilterCount(count)

        } else {
            setFilterCount(0)
        }
    }

    /**
     * The function `handleApplyFilter` is used to apply filters to a set of search parameters and
     * update the search results accordingly.
     */
    const handleApplyFilter = (type) => {
        setEmptyScreenMessage("No matching records found.");
        let params = Object.fromEntries(searchParams);
        if(type) {
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                if(FilterCheckbox[item]?.length !== 0 ) {
                    let val = ""
                    FilterCheckbox[item].map((key) => {
                        val += `${key},`
                    })
                    params[item] = val.slice(0, -1)
                    setSearchParams({ ...params})
                    flag = false
                } else {
                    delete params[item] 
                    setSearchParams({ ...params})  
                }
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
        } else {
            delete params.filter
            Object.keys(FilterCheckbox).map((item) => {
                delete params[item]   
            })
            setSearchParams({ ...params})
            setFilterCheckBox([])
        }
        getCount(type)
    }
    
    return (
        <>
            <CardHeader noPadding>
                <TopBarWithShadow
                    AddButton={true}
                    SearchInput={true}
                    Tittle={searchParams.get('type') === 'ledger' ? 'Ledgers' : searchParams.get('type') === 'group' ? 'Groups' : 'Ledgers/Groups'}
                    AddButtonName={'Add Ledger/Group'}
                    SearchValue={searchFieldDebounce}
                    handleOnClickSearch={setsearchFieldDebounce}
                    optimizedFn={optimizedFn}
                    isClick={"/main-hub/groups-ledgers/add-groups-ledgers"}
                    handleApplyFilter={handleApplyFilter}
                    FilterCheckbox={FilterCheckbox}
                    setFilterCheckBox={setFilterCheckBox}
                    filterCount={filterCount}
                    searchParams={searchParams}
                    customSearchPlaceHolder={`Ledger/Group Name`}
                    // status={searchParams.get('type') === 'group' ? "Groups" : "Ledgers"}  
                    // status={searchParams.get('type') === 'group' ? "Groups" : "Ledgers"}
                    status={searchParams.get('type')!=null?(searchParams.get('type')==='ledger'?"ledgers":"groups"):null}
                    statusBarList={['Ledgers','Groups']}
                    handleFilters={handleFilters}
                />
                <CardHeader body>
                    {loading ? <ItemShimmer />
                        : <>
                            <Table
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickSort={handleSearchParams}
                                sortValue={searchParams.get('sort') || ''}
                                setConfirmationState={setConfirmationState}
                                email={email}
                                getBranch={getBranch}
                                searchParams={searchParams}
                            // setLoading={setLoading}
                            />
                            {(List?.total_count > 10) && <Pagination
                                TotalCount={List.total_count}
                                totalPageNumber={Math.ceil(List.total_count / 10)}
                                selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                            />}
                        </>
                    }</CardHeader>
            </CardHeader>
            {Object.keys(confirmationState)?.length > 0 && confirmationState?.status  && 
            <AnimatedModel 
                Children={
                    <ConfirmationPrompt 
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${confirmationState.status==='Reset Password'?'Reset Password':`${confirmationState.status} User`} `}
                        message = {`Are you sure you want to ${confirmationState.status === 'Reset Password' ? `${confirmationState.status} for` : confirmationState.status} this user ?`}
                        buttonName = {confirmationState.status}
                        loadingActivation={loadingActivation}
                    />
                }
            />  
            }
        </>
    );
}

export default ManageGroupsLedgers;
